module.exports = __webpack_public_path__ + "img/max-logo.a7a43282.png";